import axios from 'axios';
import { showToRoles } from '../utils';
import { User } from '../types';

class ClientYard {
  getClientsForYardShort = (data: any) =>
    axios
      .get(`/client-yards/clients`, {
        params: data.params,
      })
      .then((res) => res.data.data);

  getYardsForClient = (data: any, user: User) => {
    let path = `/clients/${data.id}/yards`;
    if (showToRoles('client', user)) {
      path = '/client-yards/yards';
    }

    return axios
      .get(`${path}`, {
        params: data.params,
      })
      .then((res) => res.data.data);
  };

  assignedClients = (props: any) => async () => {
    if (!props.id && !props.yardCompanyId) return [];

    const res = await this.getClientsForYardShort({
      params: { yardId: props.id, notLoading: true },
    });

    return res
      .filter((obj: any) => obj.status === 'ACTIVE')
      .map((obj: any) => ({
        label: obj.client.code,
        id: obj.client.id,
        disabled: !!props.disabledClientIds?.includes(obj.client.id),
      }));
  };

  assignedYards = (props: any, user: User) => async () => {
    if (!props.id) return [];

    const res = await this.getYardsForClient({ id: props.id, params: { notLoading: true } }, user);

    if (showToRoles('client', user))
      return res
        .filter((obj: any) => obj.status === 'ACTIVE')
        .map((obj: any) => ({ label: obj.yard.name, id: obj.yard.id }));

    return res.active.map((obj: any) => ({ label: obj.yard.name, id: obj.yard.id }));
  };

  sendContract = async (props: any) =>
    axios.post(
      '/mailer/client-interest-in-yard',
      {
        yardId: props.yardId,
      },
      { params: { notLoading: true } },
    );
}

export const clientYardService = new ClientYard();
